import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export const transaksiJurnalTable = (handleDelete, handleShowDetail) => {
  return [
    {
      title: "No. Transaksi",
      render: (rowData) => {
        return <span>{rowData.nomor_transaksi_jurnal}</span>;
      },
    },
    {
      title: "Tanggal Transaksi",
      render: (rowData) => {
        return <span>{rowData.tanggal_transaksi}</span>;
      },
    },
    {
      title: "Keterangan Transaksi Jurnal",
      render: (rowData) => {
        return <span>{rowData.keterangan_transaksi_jurnal}</span>;
      },
    },
    {
      title: "Debet",
      render: (rowData) => {
        return (
          <span>{rowData.kode_akun_debet + "-" + rowData.nama_akun_debet}</span>
        );
      },
    },
    {
      title: "Kredit",
      render: (rowData) => {
        return (
          <span>
            {rowData.kode_akun_kredit + "-" + rowData.nama_akun_kredit}
          </span>
        );
      },
    },
    {
      title: "Jumlah",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.jumlah_transaksi_jurnal)}</span>;
      },
    },
    {
      title: "Created By",
      render: (rowData) => {
        return <span>{rowData.nama_user}</span>;
      },
    },
    {
      title: "Created At",
      render: (rowData) => {
        return <span>{rowData.created_at}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleDelete(rowData)}
            >
              Hapus
            </button>
            <button
              className="bg-lightBlue-500 hover:bg-lightBlue-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleShowDetail(rowData)}
            >
              <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
            </button>
          </>
        );
      },
    },
  ];
};
